import React from 'react';
import { IconButton, Typography, Button, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelActions, ExpansionPanelDetails, } from '@material-ui/core';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Add from '@material-ui/icons/Add';
class ListEditor extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            showAddNewEditor: false,
            stagedValue: undefined,
            expandedIndex: -1,
        };
    }
    render() {
        const { setValue, propertyOptions, propertyKey, serverUrl, source } = this.props;
        const value = this.props.value || [];
        return (React.createElement("div", null,
            value.map((v, index) => (React.createElement(ExpansionPanel, { expanded: this.state.expandedIndex === index, onChange: (e, expanded) => this.setState({ expandedIndex: expanded ? index : -1 }), key: index },
                React.createElement(ExpansionPanelSummary, { expandIcon: React.createElement(ExpandMore, null) },
                    React.createElement(Typography, null, this.props.displayNameFormat && this.props.displayNameFormat(v, index))),
                React.createElement(ExpansionPanelDetails, null,
                    React.createElement(this.props.itemComponent, { source: source, serverUrl: serverUrl, propertyOptions: propertyOptions, propertyKey: propertyKey, value: v, setValue: (newValue) => {
                            if (newValue) {
                                const newValues = [...value];
                                newValues[index] = newValue;
                                setValue(newValues);
                            }
                            else {
                                setValue(value.filter((_, i) => index !== i));
                            }
                        } })),
                React.createElement(ExpansionPanelActions, null,
                    React.createElement(Button, { onClick: () => setValue(value.filter((_, i) => index !== i)) }, "Remove"))))),
            this.state.showAddNewEditor && (React.createElement(this.props.itemComponent, { source: source, serverUrl: serverUrl, propertyOptions: propertyOptions, propertyKey: propertyKey, value: this.state.stagedValue, setValue: (newValue) => {
                    this.setState({
                        stagedValue: newValue,
                    });
                } })),
            this.state.showAddNewEditor ? (React.createElement("div", null,
                React.createElement(Button, { onClick: () => this.setState({
                        showAddNewEditor: false,
                        stagedValue: undefined,
                    }) }, "Cancel add"),
                React.createElement(Button, { onClick: () => {
                        const { stagedValue } = this.state;
                        const newValues = [...value, stagedValue];
                        setValue(newValues);
                        this.setState({
                            stagedValue: undefined,
                            showAddNewEditor: false,
                        });
                    } }, "Add item"))) : (React.createElement(IconButton, { onClick: () => this.setState({
                    showAddNewEditor: true,
                }) },
                React.createElement(Add, null)))));
    }
}
export default function (options) {
    return (props) => React.createElement(ListEditor, Object.assign({}, props, options));
}
